import { render, staticRenderFns } from "./ModalInformation.vue?vue&type=template&id=779df891&scoped=true&"
import script from "./ModalInformation.vue?vue&type=script&lang=js&"
export * from "./ModalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779df891",
  null
  
)

export default component.exports